import styled from 'styled-components'

import { theme } from 'styles/theme'

const { space } = theme

export const Wrapper = styled.div`
  padding: 0 ${space['spacing-xs']};
  text-align: center;
  white-space: pre-line;

  > * {
    margin-bottom: ${space['spacing-sm']};
  }
`
